const Testimonial = ({prm}) =>{
    return (              
    <div>
        <div className="testimony-layout-1">
            <p className="testimony-text">{prm.description}</p>
            <div className="testimony-info">
                <h4>{prm.name}</h4>
                <img className="img-responsive1" src="/images/star.png" alt="Client Image" />
            </div>
        </div>
    </div>
    );
}

export default Testimonial